module.exports = __webpack_public_path__ + "img/image1.9841082d.png";